// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppIntegrationsRouteImport } from './routes/_app/integrations'
import { Route as AppInsightsRouteImport } from './routes/_app/insights'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppWalletsIndexRouteImport } from './routes/_app/wallets/index'
import { Route as AppOrganisationsIndexRouteImport } from './routes/_app/organisations/index'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders/index'
import { Route as AppMachinesIndexRouteImport } from './routes/_app/machines/index'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app/invoices/index'
import { Route as AppWalletsOrganisationIdRouteImport } from './routes/_app/wallets/$organisationId'
import { Route as AppOrganisationsOrganisationIdRouteImport } from './routes/_app/organisations/$organisationId'
import { Route as AppOrdersOrderIdRouteImport } from './routes/_app/orders/$orderId'
import { Route as AppMachinesMachineCodeRouteImport } from './routes/_app/machines/$machineCode'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppUsersOrganisationIdRouteImport } from './routes/_app/users/$organisationId'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products/index'
import { Route as AppProductsOrganisationIdRouteImport } from './routes/_app/products/$organisationId'
import { Route as AppOrganisationsOrganisationIdEditRouteImport } from './routes/_app/organisations/$organisationId/edit'
import { Route as AppUsersOrganisationIdIndexRouteImport } from './routes/_app/users/$organisationId/index'
import { Route as AppUsersOrganisationIdSystemManagersRouteImport } from './routes/_app/users/$organisationId/system-managers'
import { Route as AppUsersOrganisationIdOperatorsRouteImport } from './routes/_app/users/$organisationId/operators'
import { Route as AppOrganisationsOrganisationIdLocationsNewRouteImport } from './routes/_app/organisations/$organisationId/locations_.new'
import { Route as AppMachinesMachineCodeOperatorsAddRouteImport } from './routes/_app/machines/$machineCode/operators_.add'
import { Route as AppUsersOrganisationIdSystemManagersIndexRouteImport } from './routes/_app/users/$organisationId/system-managers/index'
import { Route as AppUsersOrganisationIdSystemManagersNewRouteImport } from './routes/_app/users/$organisationId/system-managers/new'
import { Route as AppUsersOrganisationIdOperatorsIndexRouteImport } from './routes/_app/users/$organisationId/operators/index'
import { Route as AppUsersOrganisationIdOperatorsNewRouteImport } from './routes/_app/users/$organisationId/operators/new'
import { Route as AppOrganisationsOrganisationIdLocationsLocationIdEditRouteImport } from './routes/_app/organisations/$organisationId/locations_.$locationId.edit'
import { Route as AppMachinesMachineCodeSlotsSlotIdReplaceRouteImport } from './routes/_app/machines/$machineCode/slots_.$slotId.replace'
import { Route as AppMachinesMachineCodeOperatorsUserIdEditRouteImport } from './routes/_app/machines/$machineCode/operators_.$userId.edit'
import { Route as AppUsersOrganisationIdSystemManagersUserIdEditRouteImport } from './routes/_app/users/$organisationId/system-managers/$userId.edit'
import { Route as AppUsersOrganisationIdOperatorsUserIdEditRouteImport } from './routes/_app/users/$organisationId/operators/$userId.edit'

const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppUsersRoute = AppUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AppRoute
          })
const AppProductsRoute = AppProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AppRoute
          })
const AppIntegrationsRoute = AppIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AppRoute
          })
const AppInsightsRoute = AppInsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => AppRoute
          })
const AppAccountRoute = AppAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AppRoute
          })
const AppWalletsIndexRoute = AppWalletsIndexRouteImport.update({
            id: '/wallets/',path: '/wallets/',getParentRoute: () => AppRoute
          })
const AppOrganisationsIndexRoute = AppOrganisationsIndexRouteImport.update({
            id: '/organisations/',path: '/organisations/',getParentRoute: () => AppRoute
          })
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
            id: '/orders/',path: '/orders/',getParentRoute: () => AppRoute
          })
const AppMachinesIndexRoute = AppMachinesIndexRouteImport.update({
            id: '/machines/',path: '/machines/',getParentRoute: () => AppRoute
          })
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
            id: '/invoices/',path: '/invoices/',getParentRoute: () => AppRoute
          })
const AppWalletsOrganisationIdRoute = AppWalletsOrganisationIdRouteImport.update({
            id: '/wallets/$organisationId',path: '/wallets/$organisationId',getParentRoute: () => AppRoute
          })
const AppOrganisationsOrganisationIdRoute = AppOrganisationsOrganisationIdRouteImport.update({
            id: '/organisations/$organisationId',path: '/organisations/$organisationId',getParentRoute: () => AppRoute
          })
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
            id: '/orders/$orderId',path: '/orders/$orderId',getParentRoute: () => AppRoute
          })
const AppMachinesMachineCodeRoute = AppMachinesMachineCodeRouteImport.update({
            id: '/machines/$machineCode',path: '/machines/$machineCode',getParentRoute: () => AppRoute
          })
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppUsersRoute
          })
const AppUsersOrganisationIdRoute = AppUsersOrganisationIdRouteImport.update({
            id: '/$organisationId',path: '/$organisationId',getParentRoute: () => AppUsersRoute
          })
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppProductsRoute
          })
const AppProductsOrganisationIdRoute = AppProductsOrganisationIdRouteImport.update({
            id: '/$organisationId',path: '/$organisationId',getParentRoute: () => AppProductsRoute
          })
const AppOrganisationsOrganisationIdEditRoute = AppOrganisationsOrganisationIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => AppOrganisationsOrganisationIdRoute
          })
const AppUsersOrganisationIdIndexRoute = AppUsersOrganisationIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppUsersOrganisationIdRoute
          })
const AppUsersOrganisationIdSystemManagersRoute = AppUsersOrganisationIdSystemManagersRouteImport.update({
            id: '/system-managers',path: '/system-managers',getParentRoute: () => AppUsersOrganisationIdRoute
          })
const AppUsersOrganisationIdOperatorsRoute = AppUsersOrganisationIdOperatorsRouteImport.update({
            id: '/operators',path: '/operators',getParentRoute: () => AppUsersOrganisationIdRoute
          })
const AppOrganisationsOrganisationIdLocationsNewRoute = AppOrganisationsOrganisationIdLocationsNewRouteImport.update({
            id: '/locations_/new',path: '/locations/new',getParentRoute: () => AppOrganisationsOrganisationIdRoute
          })
const AppMachinesMachineCodeOperatorsAddRoute = AppMachinesMachineCodeOperatorsAddRouteImport.update({
            id: '/operators_/add',path: '/operators/add',getParentRoute: () => AppMachinesMachineCodeRoute
          })
const AppUsersOrganisationIdSystemManagersIndexRoute = AppUsersOrganisationIdSystemManagersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppUsersOrganisationIdSystemManagersRoute
          })
const AppUsersOrganisationIdSystemManagersNewRoute = AppUsersOrganisationIdSystemManagersNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AppUsersOrganisationIdSystemManagersRoute
          })
const AppUsersOrganisationIdOperatorsIndexRoute = AppUsersOrganisationIdOperatorsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppUsersOrganisationIdOperatorsRoute
          })
const AppUsersOrganisationIdOperatorsNewRoute = AppUsersOrganisationIdOperatorsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AppUsersOrganisationIdOperatorsRoute
          })
const AppOrganisationsOrganisationIdLocationsLocationIdEditRoute = AppOrganisationsOrganisationIdLocationsLocationIdEditRouteImport.update({
            id: '/locations_/$locationId/edit',path: '/locations/$locationId/edit',getParentRoute: () => AppOrganisationsOrganisationIdRoute
          })
const AppMachinesMachineCodeSlotsSlotIdReplaceRoute = AppMachinesMachineCodeSlotsSlotIdReplaceRouteImport.update({
            id: '/slots_/$slotId/replace',path: '/slots/$slotId/replace',getParentRoute: () => AppMachinesMachineCodeRoute
          })
const AppMachinesMachineCodeOperatorsUserIdEditRoute = AppMachinesMachineCodeOperatorsUserIdEditRouteImport.update({
            id: '/operators_/$userId/edit',path: '/operators/$userId/edit',getParentRoute: () => AppMachinesMachineCodeRoute
          })
const AppUsersOrganisationIdSystemManagersUserIdEditRoute = AppUsersOrganisationIdSystemManagersUserIdEditRouteImport.update({
            id: '/$userId/edit',path: '/$userId/edit',getParentRoute: () => AppUsersOrganisationIdSystemManagersRoute
          })
const AppUsersOrganisationIdOperatorsUserIdEditRoute = AppUsersOrganisationIdOperatorsUserIdEditRouteImport.update({
            id: '/$userId/edit',path: '/$userId/edit',getParentRoute: () => AppUsersOrganisationIdOperatorsRoute
          })





const AppProductsRouteChildren = {
  AppProductsOrganisationIdRoute: AppProductsOrganisationIdRoute,AppProductsIndexRoute: AppProductsIndexRoute
}

const AppProductsRouteWithChildren = AppProductsRoute._addFileChildren(AppProductsRouteChildren)




const AppUsersOrganisationIdOperatorsRouteChildren = {
  AppUsersOrganisationIdOperatorsNewRoute: AppUsersOrganisationIdOperatorsNewRoute,AppUsersOrganisationIdOperatorsIndexRoute: AppUsersOrganisationIdOperatorsIndexRoute,AppUsersOrganisationIdOperatorsUserIdEditRoute: AppUsersOrganisationIdOperatorsUserIdEditRoute
}

const AppUsersOrganisationIdOperatorsRouteWithChildren = AppUsersOrganisationIdOperatorsRoute._addFileChildren(AppUsersOrganisationIdOperatorsRouteChildren)




const AppUsersOrganisationIdSystemManagersRouteChildren = {
  AppUsersOrganisationIdSystemManagersNewRoute: AppUsersOrganisationIdSystemManagersNewRoute,AppUsersOrganisationIdSystemManagersIndexRoute: AppUsersOrganisationIdSystemManagersIndexRoute,AppUsersOrganisationIdSystemManagersUserIdEditRoute: AppUsersOrganisationIdSystemManagersUserIdEditRoute
}

const AppUsersOrganisationIdSystemManagersRouteWithChildren = AppUsersOrganisationIdSystemManagersRoute._addFileChildren(AppUsersOrganisationIdSystemManagersRouteChildren)



const AppUsersOrganisationIdRouteChildren = {
  AppUsersOrganisationIdOperatorsRoute: AppUsersOrganisationIdOperatorsRouteWithChildren,AppUsersOrganisationIdSystemManagersRoute: AppUsersOrganisationIdSystemManagersRouteWithChildren,AppUsersOrganisationIdIndexRoute: AppUsersOrganisationIdIndexRoute
}

const AppUsersOrganisationIdRouteWithChildren = AppUsersOrganisationIdRoute._addFileChildren(AppUsersOrganisationIdRouteChildren)



const AppUsersRouteChildren = {
  AppUsersOrganisationIdRoute: AppUsersOrganisationIdRouteWithChildren,AppUsersIndexRoute: AppUsersIndexRoute
}

const AppUsersRouteWithChildren = AppUsersRoute._addFileChildren(AppUsersRouteChildren)




const AppMachinesMachineCodeRouteChildren = {
  AppMachinesMachineCodeOperatorsAddRoute: AppMachinesMachineCodeOperatorsAddRoute,AppMachinesMachineCodeOperatorsUserIdEditRoute: AppMachinesMachineCodeOperatorsUserIdEditRoute,AppMachinesMachineCodeSlotsSlotIdReplaceRoute: AppMachinesMachineCodeSlotsSlotIdReplaceRoute
}

const AppMachinesMachineCodeRouteWithChildren = AppMachinesMachineCodeRoute._addFileChildren(AppMachinesMachineCodeRouteChildren)




const AppOrganisationsOrganisationIdRouteChildren = {
  AppOrganisationsOrganisationIdEditRoute: AppOrganisationsOrganisationIdEditRoute,AppOrganisationsOrganisationIdLocationsNewRoute: AppOrganisationsOrganisationIdLocationsNewRoute,AppOrganisationsOrganisationIdLocationsLocationIdEditRoute: AppOrganisationsOrganisationIdLocationsLocationIdEditRoute
}

const AppOrganisationsOrganisationIdRouteWithChildren = AppOrganisationsOrganisationIdRoute._addFileChildren(AppOrganisationsOrganisationIdRouteChildren)



const AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,AppInsightsRoute: AppInsightsRoute,AppIntegrationsRoute: AppIntegrationsRoute,AppProductsRoute: AppProductsRouteWithChildren,AppUsersRoute: AppUsersRouteWithChildren,AppIndexRoute: AppIndexRoute,AppMachinesMachineCodeRoute: AppMachinesMachineCodeRouteWithChildren,AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,AppOrganisationsOrganisationIdRoute: AppOrganisationsOrganisationIdRouteWithChildren,AppWalletsOrganisationIdRoute: AppWalletsOrganisationIdRoute,AppInvoicesIndexRoute: AppInvoicesIndexRoute,AppMachinesIndexRoute: AppMachinesIndexRoute,AppOrdersIndexRoute: AppOrdersIndexRoute,AppOrganisationsIndexRoute: AppOrganisationsIndexRoute,AppWalletsIndexRoute: AppWalletsIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthLoginRoute: AuthLoginRoute,AuthResetPasswordRoute: AuthResetPasswordRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren,AuthRoute: AuthRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)